import React from "react";
import { ThemeProvider } from "@mui/material";
import { Navigate, Route, Routes } from "react-router-dom";
import { theme } from "./theme/theme";
import SnackProvider from "./services/SnakbarProvider";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import PurchaseOrdersPage from "./pages/PurchaseOrdersPage";
import PurchaseOrderDetailPage from "./pages/PurchaseOrderDetailPage";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <SnackProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <PurchaseOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/:id"
            element={
              <ProtectedRoute>
                <PurchaseOrderDetailPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/orders" replace />} />
        </Routes>
      </SnackProvider>
    </ThemeProvider>
  );
}

export default App;
